module.exports = __webpack_public_path__ + "static/media/Review.dfa28369.png";